<template>
<div id="siteframe">
	<!-- content -->
	<div id="content" style="padding:0;">
		<div id="_page_content"><div class="column_100">
	<div id="main" min_height="400" style="; width: 100%"><div>
	<div class="heroband" style="background: #1e2338 url(/static/images/hero-radiology.png) center center no-repeat; background-size: cover;">
<h1>Making Your Data Meaningful</h1>
<p style="color:white !important;">Turn your mountain of RIS/PACS Data into answers in one click.</p>
</div></div>


<div>
	<div class="band bg-gray" style="background: #f2f2f2;">
<div class="container">
<div class="band-content">
<div class="column span-4"><img id="icon1" alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-hover.png">
<h3>Hover</h3>
<p>Scan findings in order to better understand general patterns presented by the data.  This allows for a quick overview of all the material presented to you.</p>
</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-filter.png">
<h3>Filter</h3>
<p>Organize data by year and location.  Manipulate variables you to access the specific information that you are in need of.</p>
</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-drill.png">
<h3>Drill</h3>
<p>Identify the data that you are in search of and dig deeper in order to understand the individual statistics behind the numbers.</p>
</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-publish.png">
<h3>Publish</h3>
<p>Make your findings public in order to increase efficiency and understanding within your business and establish credibility amongst your customers.</p>
</div>
<div style="clear: both;">&nbsp;</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-share.png">
<h3>Share</h3>
<p>Simply and instantly allow others access to information that is pertinent to them and to the success of your business. Our software allows you to be immediately connected to everyone within your network.</p>
</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-mobile.png">
<h3>Mobile-Friendly</h3>
<p>Access and share your dashboards from your mobile phone and enjoy the freedom of being able to take your business with you wherever you go.</p>
</div>
<div class="column span-4"><img alt="Infinitt Business Analytics" class="floater" src="/static/images/icon-dashboard.png">
<h3>Dashboards</h3>
<p>Overview, Productivity, Turn Around Time, Scheduling, Referrals, Modality Specific, and Clinical Quality Measurement Dashboards.  These allow you complete control over every aspect of your business.</p>
</div>
<div class="column span-4">
<div class="ctabox" style="margin: 5px;">
<h3>Get a Free Demo</h3>
<p style="margin: 0 0 10px 0;">See how you can stay on top of any internal or external influences that are affecting your business.</p>
<p class="center"><a href="/#/free-demo/"><button class="button">Free Demo</button></a></p>
</div>
</div>
</div>
</div>
</div></div>


</div></div>
<div style="clear: both;"></div>
</div>		<div style="clear: both;"></div>
	</div>
	<!-- end content -->	
</div>
</template>
<style>

p{
    color: #8B8B8B!important;
}
</style>
<script>
    import {EventBus} from '../event-bus.js'

    export default {
        name: 'features',
        data () {
            return {
               
            }
        },
        mounted(){

            
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Features.vue